module.exports = __webpack_public_path__ + "images/emoji/tropical_drink.f8620e5c8ae222bdc0ab.png";